import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import { getPartner } from '../../../../../../lib/access.es6';
import { formatPremium } from '../utils/calculations';

const useStyles = makeStyles(() => ({
  tableWrapper: {
    '& table': {
      width: '100%',
      background: '#FFFFFF',
      border: '1px solid #A7A7A7',
      marginBottom: '20px',
      borderCollapse: 'collapse',
      '& tr': {
        borderTop: '1px solid #A7A7A7',
      },
      '& th': {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '11px',
        lineHeight: '13px',
        color: '#000000',
        padding: '10px 8px',
        borderRight: '1px solid #A7A7A7',
        backgroundColor: '#f5f5f5',
        textAlign: 'left'
      },
      '& td': {
        fontFamily: 'open sans',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '15px',
        color: '#000000',
        padding: '10px 8px',
        borderRight: '1px solid #A7A7A7',
        verticalAlign: 'top'
      }
    }
  },
  benefitList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: '4px',
      fontSize: '11px'
    }
  },
  changeIndicator: {
    fontWeight: '600',
    '&.increase': {
      color: '#388e3c'
    },
    '&.decrease': {
      color: '#d32f2f'
    },
    '&.unchanged': {
      color: '#666'
    }
  }
}));

const MemberComparisonTable = ({ originalMembers, updatedMembers, title }) => {
  const classes = useStyles();
  const currencyCode = getPartner().country.currency_code;

  if (!originalMembers || originalMembers.length === 0) {
    return null;
  }

  return (
    <section style={{ marginBottom: '30px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h6 style={{ marginBottom: '10px', fontSize: '16px', fontWeight: '600' }}>{title}</h6>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th style={{ width: '15%' }}>Member</th>
                  <th style={{ width: '10%' }}>Relationship</th>
                  <th style={{ width: '25%' }}>Current Benefits</th>
                  <th style={{ width: '12%' }}>Current Premium</th>
                  <th style={{ width: '25%' }}>New Benefits</th>
                  <th style={{ width: '12%' }}>New Premium</th>
                  <th style={{ width: '10%' }}>Change</th>
                </tr>
              </thead>
              <tbody>
                {originalMembers.map((originalMember, index) => {
                  const updatedMember = updatedMembers.find(m => m.uuid === originalMember.uuid);

                  if (!updatedMember) return null;

                  const originalPremium = originalMember.premium_amount_in_cents || 0;
                  const newPremium = updatedMember.premium_amount_in_cents || 0;
                  const premiumDiff = newPremium - originalPremium;
                  const changeClass = premiumDiff > 0 ? 'increase' : (premiumDiff < 0 ? 'decrease' : 'unchanged');

                  return (
                    <tr key={originalMember.uuid || index}>
                      <td>
                        {originalMember.first_name} {originalMember.last_name}
                      </td>
                      <td>{originalMember.relationship}</td>
                      <td>
                        <ul className={classes.benefitList}>
                          {originalMember.benefits && originalMember.benefits.map((benefit, i) => (
                            <li key={i}>
                              <strong>{benefit.type}</strong>
                              <br />
                              Cover: {currencyCode} {formatPremium(benefit.cover_amount_in_cents || 0)}
                              {benefit.premium_amount > 0 && (
                                <> (Premium: {currencyCode} {formatPremium(benefit.premium_amount)})</>
                              )}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: '600' }}>
                        {currencyCode} {formatPremium(originalPremium)}
                      </td>
                      <td>
                        <ul className={classes.benefitList}>
                          {updatedMember.benefits && updatedMember.benefits.map((benefit, i) => (
                            <li key={i}>
                              <strong>{benefit.type}</strong>
                              <br />
                              Cover: {currencyCode} {formatPremium(benefit.cover_amount_in_cents || 0)}
                              {benefit.premium_amount > 0 && (
                                <> (Premium: {currencyCode} {formatPremium(benefit.premium_amount)})</>
                              )}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: '600' }}>
                        {currencyCode} {formatPremium(newPremium)}
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <span className={`${classes.changeIndicator} ${changeClass}`}>
                          {premiumDiff > 0 && '+'}
                          {currencyCode} {formatPremium(Math.abs(premiumDiff))}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Grid>
      </Grid>
    </section>
  );
};

export default MemberComparisonTable;
